module.exports = __webpack_public_path__ + "static/media/es-internal.24b488f9.mp4";